<script>
import options from './StafetDonationTaendLysStepThree.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-donation-step-three kb-optimizely-forms"
  >
    <h2 class="kb-stafet-step__title">
      {{ labels.yourInformationTitle }}
    </h2>

    <div class="kb-stafet-step__input-wrapper">
      <div
        class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
      >
        <FormInputTextField
          v-model="firstName"
          fieldName="firstName"
          :modelValue="firstName"
          :label="labels.yourInformationFirstNameLabel"
          :isRequired="true"
          :onChangeCallback="(e) => validateField('firstName', e.target.value)"
          :errorMessageLabel="labels.yourInformationFirstNameErrorMessage"
          :isValidationError="showFirstNameErrorMessage"
        />

        <FormInputTextField
          v-model="lastName"
          fieldName="lastName"
          :modelValue="lastName"
          :label="labels.yourInformationLastNameLabel"
          :isRequired="true"
          :onChangeCallback="(e) => validateField('lastName', e.target.value)"
          :errorMessageLabel="labels.yourInformationLastNameErrorMessage"
          :isValidationError="showLastNameErrorMessage"
        />
      </div>

      <FormInputTextField
        v-model="email"
        fieldName="email"
        :modelValue="email"
        :label="labels.yourInformationEmailLabel"
        :isRequired="true"
        type="email"
        :errorMessageLabel="labels.yourInformationEmailErrorMessage"
        :onChangeCallback="(e) => validateField('email', e.target.value)"
        :isValidationError="showEmailErrorMessage"
      />

      <FormCheckbox 
        v-model="isAnonymous"
        fieldName="isAnonymous"
        :modelValue="isAnonymous"
        :label="labels.yourInformationAnonymousLabel"
        :onChangeCallback="(e) => validateField('isAnonymous', e.target.checked)"
      />
    </div>

    <StafetPayment
      :title="labels.yourInformationTotalTitle"
      :basket="basket"
      :inTotalLabel="labels.yourInformationTotal"
      :inTotalPrice="basketTotalPrice.toString()"
    />

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationLastStep"
      :previousStepCallback="() => previousStepCallback(stepModel)"
      :previousStepLabel="labels.formNavigationPreviousStep"
    />
  </article>
</template>
